// COPY de apps/desktop/src/...; dedup em F13 via packages/shared-ui.
import type { CSSProperties } from 'react';
import { Card } from '../../design-system/components/Card';

export interface StatCardGauge {
  /** Valor atual normalizado (0–1) na régua. */
  value: number;
  /** Início da faixa saudável, normalizado (0–1). */
  bandStart: number;
  /** Fim da faixa saudável, normalizado (0–1). */
  bandEnd: number;
  /** Descrição acessível da régua (ex.: "62% — acima da faixa recomendada"). */
  label: string;
}

interface StatCardProps {
  label: string;
  value: string;
  helper?: string;
  deltaPct?: number;
  /** Régua de coaching: faixa saudável + posição atual. */
  gauge?: StatCardGauge;
}

function formatDelta(deltaPct: number): string {
  const sign = deltaPct > 0 ? '+' : '';
  return `${sign}${deltaPct.toFixed(1)}%`;
}

function pct(fraction: number): string {
  return `${Math.max(0, Math.min(1, fraction)) * 100}%`;
}

export function StatCard({ label, value, helper, deltaPct, gauge }: StatCardProps) {
  const tone =
    deltaPct === undefined
      ? 'neutral'
      : deltaPct > 0
        ? 'positive'
        : deltaPct < 0
          ? 'negative'
          : 'neutral';

  return (
    <Card padding="compact">
      <div className="stack-sm f4-stat-card">
        <span className="label">{label}</span>
        <span className="f4-stat-card__value">{value}</span>
        {gauge !== undefined ? (
          <div
            className="f4-stat-card__gauge"
            data-off-band={gauge.value < gauge.bandStart || gauge.value > gauge.bandEnd}
            role="img"
            aria-label={gauge.label}
            style={
              {
                '--gauge-value': pct(gauge.value),
                '--gauge-band-start': pct(gauge.bandStart),
                '--gauge-band-size': pct(gauge.bandEnd - gauge.bandStart),
              } as CSSProperties
            }
          >
            <span className="f4-stat-card__gauge-band" />
            <span className="f4-stat-card__gauge-tick" />
          </div>
        ) : null}
        <div className="row f4-stat-card__footer">
          {helper !== undefined ? <span className="muted">{helper}</span> : null}
          {deltaPct !== undefined ? (
            <span className="f4-stat-card__delta" data-tone={tone}>
              {formatDelta(deltaPct)}
            </span>
          ) : null}
        </div>
      </div>
    </Card>
  );
}
